import { render, staticRenderFns } from "./TrainingEventExBundlesPanel.vue?vue&type=template&id=8c9c3a1e&scoped=true&"
import script from "./TrainingEventExBundlesPanel.vue?vue&type=script&lang=ts&"
export * from "./TrainingEventExBundlesPanel.vue?vue&type=script&lang=ts&"
import style0 from "./TrainingEventExBundlesPanel.vue?vue&type=style&index=0&id=8c9c3a1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9c3a1e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VIcon,VProgressLinear,VSpacer})
